import _sfc_main from "./RoomTime.vue2.mjs";
/* empty css               */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "timing" }, [_vm._v(_vm._s(_setup.formattedTime))]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "108b13c2"
);
const RoomTime = __component__.exports;
export {
  RoomTime as default
};
